module.exports = __webpack_public_path__ + "media/39.cf852b8b.mp3";